module.exports = __webpack_public_path__ + "static/p-logo--shopify-fa1f6a7dc06cf1b5ee16caf877fa2381.png";